'use strict';
define([
    '../../../../lib/domQ',
    '../dockOverlay/Index',
    '../carousel/Index',
    './service',
    '../analytics',
    '../links/cookieService',
    '../../data/config/app'
], function (domQ, DockOverlay, Carousel, miniBagService, analytics, cookieService, config) {

    var ITEM_LBL = 'item',
        ITEMS_LBL = 'items',
        BAG_LBL = 'Bag',
        QTY_LBL = 'Qty',
        BAG_ITEM_LBL = 'Shopping bag with',
        BAG_ZERO_LBL = 'Your shopping bag is empty';

    /**
     * Creates a new MiniBagOverlay component.
     * @constructor
     * @param {Object} element Overlay DOM element
     * @param {Object} options
     */
    function MiniBagOverlay(element, options) {
        this.element = element;
        this.options = this.getOptions(options);
        this.target = document.querySelector(this.options.targetSelector);

        this.overlay = new DockOverlay(this.element, this.target, this.options);

        // subscribe basket updation
        this.bindEvents();
    }


    /**
     * Initializes multiple mini bag overlay components.
     * @param {Object} elements - Nodelist DOM elements
     * @returns {Object} - Mini bag overlay component list
     */
    MiniBagOverlay.initialize = function (elements, options) {
        var list = [];

        if (!elements.length) {
            return false;
        }

        for (var i = 0, n = elements.length; i < n; i++) {
            list.push(new MiniBagOverlay(elements[i], options));
        }

        return list;
    };

    MiniBagOverlay.prototype = {

        /**
         * Returns overlay configuration options
         * @returns {Object} options Configuration hash object
         */
        getOptions: function (options) {
            return Object.assign({}, options, {
                targetSelector: this.element.getAttribute('data-mini-bag-link'),
                align: this.element.getAttribute('data-mini-bag-align'),
                direction: this.element.getAttribute('data-mini-bag-direction')
            });
        },

        /**
         * Bind load and change data event handlers
         */
        bindEvents: function () {
            if (parseInt(this.getBasketSize(), 10) > 0) {
                this.removeOnInitShowEventHandler = this.overlay.onInitShowEvent(this.loadData.bind(this));
            } else {
                this.overlay.disable();
            }

            miniBagService.onChange(this.basketUpdated.bind(this));
        },

        /**
         * Initiates request to load basket details
         */
        loadData: function () {

            // remove on init show event
            if (this.removeOnInitShowEventHandler) {
                this.removeOnInitShowEventHandler();
            }

            miniBagService.load(this.options.miniBagCMD, this.options.requestParams);
        },

        /**
         * Updates mini bag overlay content/carousel
         * @param {Object} data Basket detail
         */
        basketUpdated: function (data) {
            this.myBagData = data;
            var BASKET_ITEM_COUNT = 2;
            data.basketDetails = (data.basketDetails || []).filter(function (item) {
                return !item.gatedPriorityAccess;
            });
            var addOnLength = 0;
            if (data.basketDetails.length > 0) {
                for (var i = 0; i < data.basketDetails.length; i++) {
                    addOnLength = addOnLength + data.basketDetails[i].childItemCount;
                }
            }
            var totalLength = data.basketDetails.length + addOnLength;
            if (data.basketDetails.length === 0) {
                this.overlay.disable();
            } else if (totalLength <= BASKET_ITEM_COUNT) {
                this.overlay.enable();
                this.insertMiniBag(this.generateMiniBagContent(data));
                this.checkoutBtnAnalyticsfunction();
                this.disableScroll(true);
            } else {
                this.insertMiniBagCarousel(this.generateMiniBagContent(data));
                this.checkoutBtnAnalyticsfunction();
                this.disableScroll(false);
                this.overlay.enable();
                this.initMiniBagCarousel();

            }

            //Update mini bag title after rendering
            this.updateBagTitleWithCount();
        },

        removeItemEvent: function () {
            var removeProductClick = document.querySelectorAll('.navigation-hdr-mini-bag__remove-item');
            for (var i = 0; i < removeProductClick.length; i++) {
                removeProductClick[i].addEventListener('click', this.removeProduct.bind(this.myBagData));
                removeProductClick[i].addEventListener('keyup', this.removeProduct.bind(this.myBagData));
            }
        },

        removeProduct: function (element) {
            var minibagData = this;
            var keyPressed = element.key || element.keyCode;
            var focusElementParentDiv = element.target.parentNode.parentNode.parentNode.parentNode;
            var focusElementDiv = focusElementParentDiv.querySelector('.navigation-mini-bag__remove-text');
            if (keyPressed === 'Enter' || keyPressed === 13) {
                removeProductOnclick(element, minibagData);
                focusElementDiv.focus();
                focusElementDiv.addEventListener('keyup', function (element) {
                    var linkUrl = element.target.querySelector('.navigation-mini-bag__remove-text a');
                    var keyPressed = element.key || element.keyCode;
                    if (keyPressed === 'Enter') {
                        if (linkUrl) {
                            window.location.href = linkUrl;
                        }
                    }
                });

            }
            else if (element.type === 'click') {
                removeProductOnclick(element, minibagData);
            }
            function removeProductOnclick(element, minibagData) {
                var spanElement = element.target || element.srcElement;
                if (spanElement.className === 'navigation-hdr-mini-bag__remove-item--icon') {
                    element = element.target.parentNode || element.srcElement.parentNode;
                    spanElement = element;
                }
                var orderItemId = spanElement.getAttribute('id');
                window.analyticsHeaderRemoveProduct(spanElement);
                var removeItemUrl = config.wcsBaseUrl +
                    config.CMD.removeItemMiniBag +
                    '?deleteChild=true&doInventorycheck=false&calculateOrder=1&resJSON=true&langId=' +
                    config.langId + '&storeId=' + config.storeId +
                    '&basketAction=remove&redirectSecureURL=&quantity_1=0&doPrice=N&isSecureFlow=false&orderItemId_1=' + orderItemId;
                miniBagService.removeItem(removeItemUrl);
                var miniBagQty;

                function calculateAddOnQuantity(childItems, orderIds) {
                    var childMiniBagQty = 0;
                    for (var k = 0; k < childItems.length; k++) {
                        for (var l = 0; l < orderIds.length; l++) {
                            if (childItems[k].orderItemId === orderIds[l]) {
                                childMiniBagQty = childMiniBagQty + childItems[k].quantity;
                            }
                        }
                    }
                    return childMiniBagQty;
                }

                var productContent = spanElement.parentNode.parentNode.parentNode.parentNode.children[0];
                spanElement.parentNode.parentNode.parentNode.style.display = 'none';
                if (document.querySelector('.navigation-hdr-mini-bag__remove-element')) {
                    var removeElement = document.querySelector('.navigation-hdr-mini-bag__remove-element').parentNode;
                    if (domQ(removeElement).hasClass('navigation-hdr-mini-bag__add-on-container')) {
                        if (removeElement.parentNode.children.length === 2) {
                            var addOnTitle = removeElement.parentNode.children[0];
                            removeElement.parentNode.removeChild(addOnTitle);
                        }
                    }
                    removeElement.parentNode.removeChild(removeElement);
                }
                var addOnContent = spanElement.parentNode.parentNode.parentNode.parentNode.children[2];
                var addOnOrderIds = [];
                if (addOnContent.children && addOnContent.children.length > 0) {
                    for (var c = 1; c < addOnContent.children.length; c++) {
                        var orderId = addOnContent.children[c].querySelector('.navigation-hdr-mini-bag__remove-item-add-on').getAttribute('id');
                        addOnOrderIds.push(orderId);
                    }
                }

                var removedItemPrice = 0.0;
                var subTotal = 0.0;

                for (var e = 0; e < minibagData.basketDetails.length; e++) {
                    if (minibagData.basketDetails[e].orderItemId === orderItemId) {
                        miniBagQty = parseInt(minibagData.basketDetails[e].quantity);
                        if (minibagData.basketDetails[e].childItemCount > 0) {
                            var childMiniBagQty = calculateAddOnQuantity(minibagData.basketDetails[e].childItems, addOnOrderIds);
                            miniBagQty = miniBagQty + childMiniBagQty;
                        }
                        removedItemPrice = parseFloat(minibagData.basketDetails[e].itemPrice * minibagData.basketDetails[e].quantity);
                        break;
                    }
                }

                addOnContent.parentNode.removeChild(addOnContent);
                domQ(productContent).removeClass('navigation-mini-bag__remove-message-display');
                domQ(productContent).addClass('navigation-hdr-mini-bag__remove-element');
                var bagCountAtag = document.querySelector('.navigation-res-nav-header__item--bag a');
                var viewBagCount = document.querySelector('.navigation-nav-header__bag-count');
                var bagIconElement = document.querySelector('.navigation-res-nav-header__item--bag .navigation-primary__menu-icon');
                var listOfItems = document.querySelector('.navigation-hdr-mini-bag--list').children;
                var listOfAddons = document.querySelectorAll('.navigation-hdr-mini-bag__add-on-container').length;
                var noOfItems = listOfItems.length + listOfAddons;
                var bagSubtotalElt = document.querySelector('.navigation-hdr-mini-bag__subtotal');
                if (noOfItems && noOfItems > 1) {
                    var appendInnerText = parseInt(viewBagCount.textContent) - miniBagQty;
                    if (noOfItems === 2) {
                        domQ(document.getElementById('miniBagOverlayHeader').children[0].children[1]).removeClass('navigation-hdr-mini-bag__carousel');
                    }
                    if (appendInnerText === 1) {
                        document.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(' + appendInnerText + ' ' + ITEM_LBL + ')';
                    } else {
                        document.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(' + appendInnerText + ' ' + ITEMS_LBL + ')';
                    }
                    domQ(viewBagCount).text(viewBagCount.textContent - miniBagQty);
                    bagCountAtag.setAttribute('aria-label', BAG_ITEM_LBL + ' ' + viewBagCount.innerHTML + ' ' + ITEMS_LBL);
                    if(minibagData.totalExDelivery) {
                        subTotal = parseFloat(bagSubtotalElt.textContent.replace(/['£', ',']/g,''));
                        bagSubtotalElt.innerText = '£' + (subTotal - removedItemPrice).toFixed(2);
                    }
                } else {
                    if (domQ(document.getElementById('miniBagOverlayHeader').children[0].children[1]).hasClass('navigation-hdr-mini-bag__carousel')) {
                        domQ(document.getElementById('miniBagOverlayHeader').children[0].children[1]).removeClass('navigation-hdr-mini-bag__carousel');
                    }
                    document.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(empty)';
                    document.querySelector('.navigation-hdr-mini-bag__cta-links--view-bag').style.display = 'none';
                    document.querySelector('.navigation-hdr-mini-bag__cta-links--checkout').style.display = 'none';
                    document.querySelector('.navigation-hdr-mini-bag__cta-links').innerText = BAG_ZERO_LBL;
                    var miniBagATag = document.querySelector('.navigation-res-nav-header__item--bag a');
                    miniBagATag.setAttribute('aria-label', 'Shopping bag with 0 item');
                    domQ(document.querySelector('.navigation-hdr-mini-bag__cta-links')).addClass('navigation-hdr-mini-bag__empty--text');
                    domQ(document.querySelector('.navigation-res-nav-header__item--bag')).removeClass('selected');
                    domQ(document.querySelector('.navigation-res-nav-header__item--checkout')).addClass('navigation-res-nav-header__item--hidden');
                    domQ(bagIconElement).removeClass('navigation-res-icon--fill-my-bag');
                    domQ(bagIconElement).addClass('navigation-res-icon--empty-my-bag');
                    domQ(document.querySelector('.navigation-res-nav-header__item--bag')).addClass('navigation-hdr-bag-unclick');
                    document.querySelector('.navigation-hdr-mini-bag__empty--text').setAttribute('tabIndex', '8');
                    domQ(document.querySelector('.navigation-chevronicon__minibag')).addClass('navigation-minibag-empty');
                    domQ(document.querySelector('.navigation-chevronicon__minibag')).removeClass('navigation-minibag-empty-display');
                    viewBagCount.innerHTML = 0;
                    bagSubtotalElt.parentElement.style.display = 'none';
                }
            }


        },

        removeAddonEvent: function () {
            var removeAddonClick = document.querySelectorAll('.navigation-hdr-mini-bag__remove-item-add-on');
            for (var i = 0; i < removeAddonClick.length; i++) {
                removeAddonClick[i].addEventListener('click', this.removeAddonProduct.bind(this.myBagData));
                removeAddonClick[i].addEventListener('keyup', this.removeAddonProduct.bind(this.myBagData));
            }
        },


        removeAddonProduct: function (element) {
            var minibagData = this;
            var keyPressed = element.key || element.keyCode;
            if ((keyPressed === 'Enter' || keyPressed === 13)) {
                removeAddonProductClick(element, minibagData);
                var AddonFocusParentDiv = element.target.parentNode.parentNode.parentNode.parentNode;
                var AddonFocusDiv = AddonFocusParentDiv.querySelector('.navigation-mini-bag__remove-confirmation-add-on');
                AddonFocusDiv.focus();
            }
            else if (element.type === 'click') {
                removeAddonProductClick(element, minibagData);
            }

            function removeAddonProductClick(element, minibagData) {
                var spanElement = element.target || element.srcElement;
                if (element.srcElement.className === 'navigation-hdr-mini-bag__remove-item--icon-add-on') {
                    element = element.srcElement.parentNode;
                    spanElement = element;
                }
                var orderItemId = spanElement.getAttribute('id');
                window.analyticsHeaderRemoveAddOn(spanElement);
                var removeItemUrl = config.wcsBaseUrl +
                    config.CMD.removeItemMiniBag +
                    '?deleteChild=true&doInventorycheck=false&calculateOrder=1&resJSON=true&langId=' +
                    config.langId + '&storeId=' + config.storeId +
                    '&basketAction=remove&redirectSecureURL=&quantity_1=0&doPrice=N&isSecureFlow=false&orderItemId_1=' + orderItemId;
                miniBagService.removeItem(removeItemUrl);
                var qty;
                var productOrderItemId = spanElement.parentNode.parentNode.parentNode.getAttribute('id');

                var removedItemPrice = 0.0;
                var subTotal = 0.0;

                function calculateAddOnQuantity(childItems, childOrderItemId) {
                    var qty;
                    for (var k = 0; k < childItems.length; k++) {
                        if (childItems[k].orderItemId === childOrderItemId) {
                            qty = parseInt(childItems[k].quantity);
                            removedItemPrice = parseFloat(childItems[k].itemPrice * qty);
                        }
                    }
                    return qty;
                }

                for (var j = 0; j < minibagData.basketDetails.length; j++) {
                    if (minibagData.basketDetails[j].orderItemId === productOrderItemId) {
                        if (minibagData.basketDetails[j].childItemCount > 0) {
                            qty = calculateAddOnQuantity(minibagData.basketDetails[j].childItems, orderItemId);
                        }
                        break;
                    }
                }
                var productContent = spanElement.parentNode.parentNode.parentNode.parentNode.children[0];
                spanElement.parentNode.parentNode.parentNode.style.display = 'none';
                if (document.querySelector('.navigation-hdr-mini-bag__remove-element')) {
                    var removeElement = document.querySelector('.navigation-hdr-mini-bag__remove-element').parentNode;
                    if (domQ(removeElement).hasClass('navigation-hdr-mini-bag__add-on-container')) {
                        if (removeElement.parentNode.children.length === 2) {
                            var addOnTitle = removeElement.parentNode.children[0];
                            removeElement.parentNode.removeChild(addOnTitle);
                        }
                    }
                    removeElement.parentNode.removeChild(removeElement);
                }
                domQ(productContent).removeClass('navigation-mini-bag__remove-message-display-add-on');
                domQ(productContent).addClass('navigation-hdr-mini-bag__remove-element');
                var viewBagCount = document.querySelector('.navigation-nav-header__bag-count');

                var listOfItems = document.querySelector('.navigation-hdr-mini-bag--list').children;
                var listOfAddons = document.querySelectorAll('.navigation-hdr-mini-bag__add-on-container').length;
                var noOfItems = listOfItems.length + listOfAddons;
                var bagSubtotalElt = document.querySelector('.navigation-hdr-mini-bag__subtotal');
                if (noOfItems > 1) {
                    var appendInnerText = parseInt(viewBagCount.textContent) - qty;
                    if (noOfItems === 2) {
                        domQ(document.getElementById('miniBagOverlayHeader').children[0].children[1]).removeClass('navigation-hdr-mini-bag__carousel');
                    }
                    if (appendInnerText === 1) {
                        document.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(' + appendInnerText + ' ' + ITEM_LBL + ')';
                    } else {
                        document.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(' + appendInnerText + ' ' + ITEMS_LBL + ')';
                    }
                    domQ(viewBagCount).text(viewBagCount.textContent - qty);
                    if(minibagData.totalExDelivery) {
                        subTotal = parseFloat(bagSubtotalElt.textContent.replace(/['£',',']/g,''));
                        bagSubtotalElt.innerText = '£' + (subTotal - removedItemPrice).toFixed(2);
                    }
                }
            }
        },

        updateBagTitleWithCount: function () {
            var bagCount = this.getBasketSize();
            var bagTitle = document.querySelector('.navigation-mini-bag__title');
            if (bagTitle && bagCount && bagCount > 0) {
                bagTitle.innerHTML = BAG_LBL + ' (' + bagCount + ' ' + ITEMS_LBL + ')';
            }
            else if (bagTitle && bagCount && bagCount === 0) {
                bagTitle.innerHTML = BAG_LBL + ' (' + bagCount + ' ' + ITEM_LBL + ')';
            }
        },
        //to enable/disable scroll
        disableScroll: function (disableScroll) {
            if (disableScroll === true) {
                domQ(this.element.querySelector('.navigation-hdr-mini-bag__ctrl--next')).addClass('disabled');
                domQ(this.element.querySelector('.navigation-hdr-mini-bag__ctrl--prev')).addClass('disabled');
            }
            else {
                this.scrollEvent();
                domQ(this.element.querySelector('.navigation-hdr-mini-bag__ctrl--next')).removeClass('disabled');
                domQ(this.element.querySelector('.navigation-hdr-mini-bag__ctrl--prev')).removeClass('disabled');

            }
        },

        checkoutBtnAnalyticsfunction: function () {
            var checkoutBtnElement = document.querySelector('.navigation-hdr-mini-bag__cta-links .navigation-hdr-btn--primary');
            analytics.bind(checkoutBtnElement, [{
                functionName: 'analyticsHeaderMiniBasketCheckoutButton',
                event: 'click'
            }]);
        },

        /**
         * Instantiate carousel component on mini bag content
         */
        initMiniBagCarousel: function () {
            new Carousel(this.overlay.element.querySelector('.navigation-hdr-mini-bag__carousel'), {
                multiple: true,
                wrapper: '.navigation-mini-bag__items-wrap',
                slider: '.navigation-hdr-mini-bag__items',
                slide: '.navigation-hdr-mini-bag__items li',
                previousBtn: '.navigation-hdr-mini-bag__ctrl--prev .navigation-hdr-ctrl--link',
                nextBtn: '.navigation-hdr-mini-bag__ctrl--next .navigation-hdr-ctrl--link',
                type: 'vertical'
            }).init();
        },

        /**
         * Insert mini bag content into DOM
         * @param {Object} content Basket detail
         */
        insertMiniBag: function (content) {
            this.overlay.content(content.innerHTML);
            this.removeItemEvent();
            this.removeAddonEvent();
        },

        /**
         * Generate DOM for Mini Bag carousel
         * @param {Object} miniBag Basket detail
         */
        insertMiniBagCarousel: function (miniBag) {
            domQ(miniBag.children[1]).addClass('navigation-hdr-mini-bag__carousel');
            this.insertMiniBag(miniBag);
        },

        scrollEvent: function () {
            var minibagContent = document.querySelector('.navigation-mini-bag__items-wrap');
            minibagContent.addEventListener('scroll', this.minibagContentScroll);
        },

        minibagContentScroll: function () {
            var minibagDiv = document.querySelector('.navigation-mini-bag__items-wrap');
            if (!domQ(minibagDiv).hasClass('navigation-hdr-mini-bag__top-line')) {
                domQ(minibagDiv).addClass('navigation-hdr-mini-bag__top-line');
            }
            if (minibagDiv.scrollTop <= 13 && domQ(minibagDiv).hasClass('navigation-hdr-mini-bag__top-line')) {
                domQ(minibagDiv).removeClass('navigation-hdr-mini-bag__top-line');
            }
        },

        /**
         * Generate DOM for Mini Bag content
         * @param {Object} data Basket detail
         */
        generateMiniBagContent: function (data) {
            var template = this.getMiniBagTemplate(),
                miniBagList = template.querySelector('.navigation-hdr-mini-bag__items'),
                miniBagListItem = miniBagList.removeChild(miniBagList.children[0]),
                generateMiniBagItem = this.generateMiniBagItem.bind(this),
                checkOutLink;

            data.basketDetails.map(function (product) {
                var node;
                if (!product.gatedPriorityAccess) {
                    node = miniBagListItem.cloneNode(true);
                    miniBagList.appendChild(generateMiniBagItem(node, product));
                }
            });
            template.querySelector('.navigation-hdr-mini-bag__cta-links .navigation-hdr-btn--secondary').setAttribute('href', data.basketLink);
            var bagCount = this.getBasketSize();
            if (bagCount && parseInt(bagCount) === 1) {
                template.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(' + parseInt(bagCount) + ' ' + ITEM_LBL + ')';
            }
            else {
                template.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(' + parseInt(bagCount) + ' ' + ITEMS_LBL + ')';
            }
            if (cookieService.getUserLoginCookieValue() || cookieService.getCookieValue('MS_AO_COOKIE')) {
                template.querySelector('.navigation-hdr-mini-bag__cta-links .navigation-hdr-btn--primary').setAttribute('href', data.checkOutLink);
            } else {
                checkOutLink = template.querySelector('.navigation-hdr-mini-bag__cta-links .navigation-hdr-btn--primary').dataset.globalCheckoutLink;
                template.querySelector('.navigation-hdr-mini-bag__cta-links .navigation-hdr-btn--primary').setAttribute('href', checkOutLink);
            }
            if(data.totalExDelivery) {
                template.querySelector('.navigation-hdr-mini-bag__subtotal-wrapper .navigation-hdr-mini-bag__subtotal').innerText = '£' + parseFloat(data.totalExDelivery.replace(/['£', ',']/g,'')).toFixed(2);
                template.querySelector('.navigation-hdr-mini-bag__cta-links').classList.add('no-border');
            } else {
                template.querySelector('.navigation-hdr-mini-bag__subtotal-wrapper').style.display = 'none';
            }
            return template;
        },

        /**
         * Generate DOM for Mini Bag content
         * @param {data} Basket detail
         */
        generateMiniBagItem: function (el, product) {
            var productTitle = el.querySelector('.navigation-hdr-mini-bag__item-title'),
                productTitleRemoveLink = el.querySelector('.navigation-mini-bag__item-title__remove'),
                productremoveTitlefocus = el.querySelector('.navigation-mini-bag__remove-text'),
                productImage = el.querySelector('.navigation-hdr-mini-bag__item-img'),
                productImageLink = el.querySelector('.navigation-hdr-mini-bag__item-img-wrap'),
                productDetailWrap = el.querySelector('.navigation-hdr-mini-bag__item-detail'),
                productInfo = productDetailWrap.removeChild(productDetailWrap.querySelector('.navigation-hdr-mini-bag__item-info')),
                productPriceInfo = productDetailWrap.removeChild(productDetailWrap.querySelector('.navigation-hdr-mini-bag__item-price')),
                productRemoveItem = productDetailWrap.removeChild(productDetailWrap.querySelector('.navigation-hdr-mini-bag__remove')),
                productAddOns = el.querySelector('.navigation-hdr-mini-bag__add-ons'),
                productAddOnHeading = productAddOns.removeChild(productAddOns.querySelector('.navigation-hdr-mini-bag__add-on-title')),
                productAddOnContainer = productAddOns.removeChild(productAddOns.querySelector('.navigation-hdr-mini-bag__add-on-container'));

            var parser = new window.DOMParser;
            var dom = parser.parseFromString(product.productTitle, 'text/html');
            var domAltText = parser.parseFromString(product.productImgeAltText, 'text/html');

            var priceInfoForAria = '';
            var addOnPriceInfoForAria = '';

            productTitle.innerText = dom.body.textContent;
            productTitle.setAttribute('href', product.productUrl);
            productTitle.href = productTitle.href + '#intid=header_minibasket_product-txt';
            productTitle.setAttribute('title', dom.body.textContent);

            productTitleRemoveLink.innerText = dom.body.textContent;
            productTitleRemoveLink.setAttribute('href', product.productUrl);
            productTitleRemoveLink.href = productTitleRemoveLink.href + '#intid=header_minibasket_removed-product-txt';
            productTitleRemoveLink.setAttribute('title', dom.body.textContent);
            productremoveTitlefocus.setAttribute('tabIndex', '8');
            productremoveTitlefocus.setAttribute('aria-label', productTitle.innerText + 'has been removed from your shopping bag , link');

            productImage.setAttribute('src', product.productImgUrl);
            productImage.setAttribute('alt', product.productImgeAltText);

            productImageLink.setAttribute('href', product.productUrl);
            productImageLink.href = productImageLink.href + '#intid=header_minibasket_product-image';
            productImageLink.setAttribute('title', domAltText.body.textContent);

            if (!product.productAttributes) {
                product.productAttributes = [];
            }

            if ((product.productAttribute) && (product.productType === 'Furniture') && (product.productDefinition === 'Sofas' || product.productDefinition === 'Armchairs' || product.productDefinition === 'Loveseats' || product.productDefinition === 'Recliners' || product.productDefinition === 'Foot Stools')) {
                product.productAttributes.push({
                    productAttrName: '',
                    productAttrValue: product.productAttribute
                });
            }
            if (product.childItems && ((product.childItems.length - product.childItemCount) >= 1) && (product.productType === 'Furniture') && (product.productDefinition === 'Sofas' || product.productDefinition === 'Armchairs' || product.productDefinition === 'Loveseats' || product.productDefinition === 'Recliners' || product.productDefinition === 'Foot Stools')) {
                for (var i = 0; i < product.childItems.length; i++) {
                    if (product.childItems[i].productType !== 'Services' && product.childItems[i].addOnColour) {
                        product.productAttributes.push({
                            productAttrName: product.childItems[i].productDefinition,
                            productAttrValue: product.childItems[i].productTitle + ', ' + product.childItems[i].addOnColour
                        });
                    }
                    else if (product.childItems[i].productType !== 'Services') {
                        product.productAttributes.push({
                            productAttrName: product.childItems[i].productDefinition,
                            productAttrValue: product.childItems[i].productTitle
                        });
                    }
                }
            }
            product.productAttributes.push({
                productAttrName: QTY_LBL,
                productAttrValue: product.quantity
            });

            function getArialabelForProduct(productAttrName, productAttrValue, index, productAttributesLength) {

                var minibagItemInfo = productDetailWrap.getAttribute('aria-label');
                if (productAttrName === 'Colour') {
                    productAttrName = '';
                }
                if (productAttrName === 'Qty') {
                    productAttrName = 'Quantity';
                }

                if (index === productAttributesLength - 1) {
                    productDetailWrap.setAttribute('aria-label', minibagItemInfo + ', ' + productAttrName + ', ' + productAttrValue + ', ' + priceInfoForAria);
                } else {
                    productDetailWrap.setAttribute('aria-label', minibagItemInfo + ', ' + productAttrName + ', ' + productAttrValue);
                }
            }

            function getArialabelForAddOnProduct(productAttrName, productAttrValue, index, productAttributesLength, productDetailWrapAddon) {
                var minibagAddOnItemInfo = productDetailWrapAddon.getAttribute('aria-label');
                if (productAttrName === 'Colour') {
                    productAttrName = '';
                }
                if (productAttrName === 'Qty') {
                    productAttrName = 'Quantity';
                }

                if (index === productAttributesLength - 1) {
                    productDetailWrapAddon.setAttribute('aria-label', minibagAddOnItemInfo + ', ' + productAttrName + ', ' + productAttrValue + ', ' + addOnPriceInfoForAria);
                } else {
                    productDetailWrapAddon.setAttribute('aria-label', minibagAddOnItemInfo + ', ' + productAttrName + ', ' + productAttrValue);
                }
            }
            if (product.quantity || product.quantity !== '') {
                var productPriceDetails = productPriceInfo.cloneNode(true);
                var totalItemPrice = product.itemPrice * product.quantity;
                var totalItemPriceRoundOff = totalItemPrice.toFixed(2);
                if (product.wasPrice) {
                    var totalWasPrice = product.wasPrice * product.quantity;
                    var totalwasPriceRoundOff = totalWasPrice.toFixed(2);
                    productPriceDetails.innerHTML = '<span class="navigation-minibasket__currentprice">' + product.currency + totalItemPriceRoundOff + '</span><span class="navigation-minibasket__wasprice">' + product.currency + totalwasPriceRoundOff + '</span>';
                    productDetailWrap.setAttribute('aria-label', productTitle.innerText);
                    priceInfoForAria = product.currency + totalItemPriceRoundOff;
                }
                else {
                    productPriceDetails.innerText = product.currency + totalItemPriceRoundOff;
                    productDetailWrap.setAttribute('aria-label', productTitle.innerText);
                    priceInfoForAria = product.currency + totalItemPriceRoundOff;
                }

                productDetailWrap.appendChild(productPriceDetails);
                product.productAttributes.map(function (detail, i) {
                    var productDetail = productInfo.cloneNode(true);

                    if ((product.productType === 'Furniture') && (product.productDefinition === 'Sofas' || product.productDefinition === 'Armchairs' || product.productDefinition === 'Loveseats' || product.productDefinition === 'Recliners' || product.productDefinition === 'Foot Stools') && (detail.productAttrName !== 'Qty')) {
                        productDetail.children[0].classList.add('navigation-minibasket-furniture__attributes');
                        productDetail.children[1].classList.add('navigation-minibasket-furniture__attributes');
                    }


                    if (detail.productAttrName === '' || detail.productAttrName === undefined) {
                        productDetail.children[1].innerText = detail.productAttrValue;
                    } else {
                        productDetail.children[0].innerText = detail.productAttrName + ': ';
                        productDetail.children[1].innerText = detail.productAttrValue;
                    }
                    getArialabelForProduct(productDetail.children[0].innerText, productDetail.children[1].innerText, i, product.productAttributes.length);
                    productDetailWrap.appendChild(productDetail);
                });
                var productRemoveButton = productRemoveItem.cloneNode(true);
                productDetailWrap.appendChild(productRemoveButton);
                var productRemoveClick = productRemoveButton.querySelector('.navigation-hdr-mini-bag__remove-item');
                productRemoveClick.setAttribute('id', product.orderItemId);
                productRemoveClick.setAttribute('aria-label', 'Remove ' + productTitle.innerText + ' button');
                productRemoveClick.setAttribute('data-productStroke', product.productStroke);
                productRemoveClick.setAttribute('data-productUpc', product.productUPC);
                productRemoveClick.setAttribute('data-productId', product.productId);
                productRemoveClick.setAttribute('data-cost', priceInfoForAria);
                productRemoveClick.setAttribute('data-quantity', product.quantity);
            }

            if (product.childItemCount > 0) {
                var productAddOnTitle = productAddOnHeading.cloneNode(true);
                productAddOnTitle.setAttribute('tabIndex', 8);
                productAddOns.appendChild(productAddOnTitle);
                product.childItems.map(function (child) {
                    if ((product.productType === 'Furniture' && child.productType === 'Services') || (product.productType !== 'Furniture')) {
                        var productAddOnList = productAddOnContainer.cloneNode(true);
                        var productAddOnWrap = productAddOnList.querySelector('.navigation-hdr-mini-bag__item-add-on');
                        var productAddOnRemoveWrap = productAddOnList.querySelector('.navigation-mini-bag__remove-confirmation-add-on');
                        var productTitleAddon = productAddOnWrap.querySelector('.navigation-hdr-mini-bag__item-title-add-on');
                        var productImageAddon = productAddOnWrap.querySelector('.navigation-hdr-mini-bag__item-img-add-on');
                        var productImageLinkAddon = productAddOnWrap.querySelector('.navigation-hdr-mini-bag__item-img-wrap-add-on');
                        var productDetailWrapAddon = productAddOnWrap.querySelector('.navigation-hdr-mini-bag__item-detail-add-on');
                        var productInfoAddon = productDetailWrapAddon.removeChild(productDetailWrapAddon.querySelector('.navigation-hdr-mini-bag__item-info-add-on'));
                        var productPriceInfoAddon = productDetailWrapAddon.removeChild(productDetailWrapAddon.querySelector('.navigation-hdr-mini-bag__item-price-add-on'));
                        var productRemoveItemAddon = productDetailWrapAddon.removeChild(productDetailWrapAddon.querySelector('.navigation-hdr-mini-bag__remove-add-on'));
                        var productAddonRemoveTitle = productAddOnRemoveWrap.querySelector('.navigation-mini-bag__item-title__remove-add-on');

                        var dom = parser.parseFromString(child.productTitle, 'text/html');
                        var domAltText = parser.parseFromString(child.productImgeAltText, 'text/html');

                        productTitleAddon.innerText = dom.body.textContent;
                        productTitleAddon.setAttribute('title', dom.body.textContent);
                        productImageAddon.setAttribute('src', child.productImgUrl);
                        productImageAddon.setAttribute('alt', child.productImgeAltText);
                        productImageLinkAddon.setAttribute('title', domAltText.body.textContent);
                        productAddonRemoveTitle.innerText = dom.body.textContent;
                        productAddonRemoveTitle.setAttribute('title', dom.body.textContent);
                        if (!child.productAttributes) {
                            child.productAttributes = [];
                        }
                        child.productAttributes.push({
                            productAttrName: 'Qty',
                            productAttrValue: child.quantity
                        });

                        if (child.quantity || child.quantity !== '') {
                            var productPriceDetailsAddon = productPriceInfoAddon.cloneNode(true);
                            var totalItemPriceAddon = child.itemPrice * child.quantity;
                            var totalItemPriceRoundOffAddon = totalItemPriceAddon.toFixed(2);
                            if (child.wasPrice) {
                                var totalWasPriceAddon = child.wasPrice * child.quantity;
                                var totalwasPriceRoundOffAddon = totalWasPriceAddon.toFixed(2);
                            }
                            if (product.productType === 'Furniture' && child.wasPrice) {
                                productPriceDetailsAddon.innerText = child.currency + totalItemPriceRoundOffAddon;
                                productDetailWrapAddon.setAttribute('aria-label', productTitleAddon.innerText);
                                addOnPriceInfoForAria = child.currency + totalItemPriceRoundOffAddon;
                            }
                            else if (child.wasPrice) {
                                productPriceDetailsAddon.innerHTML = '<span class="navigation-minibasket__currentprice">' + child.currency + totalItemPriceRoundOffAddon + '</span><span class="navigation-minibasket__wasprice">' + child.currency + totalwasPriceRoundOffAddon + '</span>';
                                productDetailWrapAddon.setAttribute('aria-label', productTitleAddon.innerText);
                                addOnPriceInfoForAria = child.currency + totalItemPriceRoundOffAddon;
                            }
                            else {
                                productPriceDetailsAddon.innerText = child.currency + totalItemPriceRoundOffAddon;
                                productDetailWrapAddon.setAttribute('aria-label', productTitleAddon.innerText);
                                addOnPriceInfoForAria = child.currency + totalItemPriceRoundOffAddon;
                            }
                            productDetailWrapAddon.appendChild(productPriceDetailsAddon);
                            child.productAttributes.map(function (detail, i) {
                                var productDetailAddon = productInfoAddon.cloneNode(true);
                                productDetailAddon.children[0].innerText = detail.productAttrName;
                                productDetailAddon.children[1].innerText = detail.productAttrValue;
                                getArialabelForAddOnProduct(productDetailAddon.children[0].innerText, productDetailAddon.children[1].innerText, i, child.productAttributes.length, productDetailWrapAddon);

                                productDetailWrapAddon.appendChild(productDetailAddon);
                            });
                            var productRemoveButtonAddon = productRemoveItemAddon.cloneNode(true);
                            productDetailWrapAddon.appendChild(productRemoveButtonAddon);
                            var productRemoveClickAddon = productRemoveButtonAddon.querySelector('.navigation-hdr-mini-bag__remove-item-add-on');
                            productRemoveClickAddon.setAttribute('id', child.orderItemId);
                            productRemoveClickAddon.setAttribute('aria-label', 'Remove ' + productTitleAddon.innerText + ' button');
                            productRemoveClickAddon.setAttribute('data-productStroke', child.productStroke);
                            productRemoveClickAddon.setAttribute('data-productUpc', child.productUPC);
                            productRemoveClickAddon.setAttribute('data-productId', child.productId);
                            productRemoveClickAddon.setAttribute('data-cost', addOnPriceInfoForAria);
                            productRemoveClickAddon.setAttribute('data-quantity', child.quantity);
                            if (product.productType === 'Furniture') {
                                productRemoveClickAddon.setAttribute('style', 'display:none');
                            }
                        }
                        productAddOnWrap.setAttribute('id', product.orderItemId);
                        productAddOnList.appendChild(productAddOnRemoveWrap);
                        productAddOnList.appendChild(productAddOnWrap);
                        productAddOns.appendChild(productAddOnList);
                    }
                });
            }
            return el;
        },

        /**
         * Returns basket size.
         * @param {string} Cookie string
         * @returns {string} Basket size value
         */
        getBasketSize: function () {
            return cookieService.getBasketSizeCookieValue() || '0';
        },

        /**
         * Returns template string for mini bag contents
         * @returns {string} mini bag template
         */
        getMiniBagTemplate: function () {
            var template = document.createElement('div');
            template.innerHTML = document.getElementById('hdr-miniBagTemplate').innerHTML;
            return template.children[0];
        }
    };

    return MiniBagOverlay;
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/miniBag/Index.js